import { skipToken } from '@reduxjs/toolkit/query';
import { useCreateDialogChip, useCreateRoute } from 'components/create-dialog/CreateDialogContext';
import Loader from 'components/Loader.tsx';
import { defaultCurrencyOption, useDefaultCurrencyCode } from 'hooks/useDefaultCurrencyCode';
import { useGetContactByIdQuery } from 'store/api/contacts.ts';
import { useGetMatterByIdQuery } from 'store/api/matters.ts';
import { ExperienceRecordFormData } from 'types/experience-records.ts';
import { getValidOptionsFromClassifier } from 'utils/formUtil';
import { useClassifiers } from 'utils/useClassifiers';
import { defaultXRFormValues } from './experienceRecordFormMapping';
import ExperienceRecordForm from './ExperienceRecordForm.tsx';

const ExperienceRecordPageAdd = () => {
    const { matterId, contactId } = useCreateRoute().params;
    const { data: matter, isLoading: isLoadingMatter } = useGetMatterByIdQuery(matterId ?? skipToken);
    const { data: contact, isLoading: isLoadingContact } = useGetContactByIdQuery(contactId ?? skipToken);
    const { classifiers, isLoading: isLoadingClassifiers } = useClassifiers({ codes: ['CURRENCY'] });
    const { code: defaultCurrencyCode, isLoading: isLoadingDefaultCurrency } = useDefaultCurrencyCode();
    useCreateDialogChip({ parent: contact?.name ?? matter?.fullName });

    const formData: ExperienceRecordFormData = {
        ...defaultXRFormValues,
        matters: matter ? [matter] : [],
        clientParty: contact ? contact : matter ? matter.clientParty : null,
        currency: defaultCurrencyOption(
            getValidOptionsFromClassifier<string, string>(classifiers['CURRENCY']),
            defaultCurrencyCode
        ),
    };

    if (isLoadingMatter || isLoadingContact || isLoadingClassifiers || isLoadingDefaultCurrency) return <Loader />;

    return <ExperienceRecordForm type="add" initialData={formData} />;
};

export default ExperienceRecordPageAdd;
